import type { ReactNode } from 'react'

import styles from './Panel.module.css'

interface PanelProps {
  title: string
  /** Secondary text or a legend, right of the title. */
  aside?: ReactNode
  children: ReactNode
}

export function Panel({ title, aside, children }: PanelProps) {
  return (
    <section className={styles.panel} aria-label={title}>
      <div className={styles.head}>
        <h3 className={styles.title}>{title}</h3>
        {typeof aside === 'string' ? <div className={styles.sub}>{aside}</div> : aside}
      </div>
      <div className={styles.body}>{children}</div>
    </section>
  )
}
